import React from "react";
import { Link } from "react-router-dom";
const HoverContent = ({ paragraph, image,setHotels,setSweets,setResorts }) => {
  const directed=()=>{
    setHotels(false);
    setSweets(false);
    setResorts(false);
  }
  return (
    <>
      <div className="resortstoggle__rightnav">
        <img src={image} alt="" />
        <p>{paragraph}</p>
        <Link to="/branch" className="bton bton--md bton--ghost" onClick={directed}>Discover More</Link>
      </div>
    </>
  );
};

export default HoverContent;
